export const images = {
  hero: "https://images.unsplash.com/photo-1512632578888-169bbbc64f33?q=80&w=1920&auto=format&fit=crop",
  about: "https://images.unsplash.com/photo-1636202339022-7d67f7447e3a?q=80&w=1200&auto=format&fit=crop",
};
